<button [type]="type" [class]="className" (click)="confirm()">
  {{ value }}
</button>
